module.exports = __webpack_public_path__ + "img/item_infected.abf73ca5.png";